export default __webpack_public_path__ + "fc36ce8.png";